/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { Rect, Svg } from 'react-native-svg'

export const CheckboxIndeterminate: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 20 20' {...props}>
        <Rect x='1' y='1' rx='2' fill='#E5E5E6' stroke='#E5E5E6' strokeWidth='2' />
        <Rect x='4' y='9' fill='#18181B' />
    </Svg>
)
